import { combineReducers } from "redux";
import signals from "./signals";
import indicators from "./indicators";
import client from "./client";
import dashboard from "./dashboard";
import mainSettings from "./mainSettings";
import initial from "./initial";
import filtersSettings from "./filtersSettings";
import storageVersion from "./storageVersion";
import logs from "./logs";

export default combineReducers({
  signals,
  indicators,
  client,
  dashboard,
  mainSettings,
  filtersSettings,
  initial,
  logs,
  storageVersion,
});
